import Spline from '@splinetool/react-spline';
import Image from 'next/image';
import { FC, useState } from 'react';
import { useDeviceDetect } from 'react-scale/hooks/use-device-detect';

const Iceberg = () => {
  const [icebergLoaded, setIcebergLoaded] = useState(false);

  return (
    <>
      <p className="md:hidden font-aeonik text-3.5xl leading-snug mb-16">
        The structured data you have already in databases is just the tip of the iceberg.
      </p>

      <div
        className="rounded-2xl relative hidden md:flex flex-col lg:h-[420px] xl:h-[512px] overflow-hidden"
        style={{
          background:
            'linear-gradient(180deg, #D1AAD7 -73.84%, #C88BC4 2.13%, #7B8FDD 37.98%, #000000 64.92%, #000000 156.86%)'
        }}
      >
        <div className="flex z-10 flex-grow-[2] items-end md:pb-10 lg:pb-10 md:pt-10 lg:pt-0 xl:pb-12 md:pl-72 lg:pl-96 xl:pl-[500px] md:pr-8 lg:pr-10 xl:pr-16">
          <p className="text-lg lg:text-xl xl:text-3.5xl">
            The structured data you have already in databases is <b>just the tip of the iceberg.</b>
          </p>
        </div>
        <div
          className="z-10 flex-grow-[3] :flex flex-col justify-center xl:justify-start items-start md:pt-10 lg:pt-10 md:pb-10 lg:pb-0 xl:pt-12 space-y-4 lg:space-y-8 rounded-b-2xl md:pl-72 lg:pl-96 xl:pl-[500px] md:pr-8 lg:pr-10 xl:pr-16"
          style={{
            background:
              !icebergLoaded &&
              'linear-gradient(180deg, #8FD3F7 0%, #025A89 77.76%, #003855 150.81%)'
          }}
        >
          <p
            className="rounded-lg px-4 xl:px-6 py-2 xl:py-4 text-lg lg:text-xl xl:text-2xl max-w-max"
            style={{
              background: 'linear-gradient(265.94deg, #1E76A5 -11.48%, #4795BF 103.31%)'
            }}
          >
            <b>80%</b> of enterprise data is unstructured.
          </p>
          <p className="text-lg lg:text-xl xl:text-2xl">
            Scale unlocks this trapped data and uses it to address your biggest challenges and
            transform your enterprise.
          </p>
        </div>
      </div>

      <div className="relative md:absolute md:inset-0 overflow-hidden pointer-events-none rounded-[10px]">
        <IcebergModel onLoad={() => setIcebergLoaded(true)} />
      </div>

      <p className="md:hidden font-aeonik text-2xl leading-10 mt-16 mb-6">
        80% of enterprise data is unstructured.
      </p>
      <p className="md:hidden font-aeonik text-3.5xl leading-snug">
        Scale unlocks this trapped data and uses it to address your biggest challenges and transform
        your enterprise.
      </p>
    </>
  );
};

const IcebergModel: FC<{ onLoad: () => void }> = ({ onLoad }) => {
  const { isDesktop } = useDeviceDetect();

  return isDesktop ? (
    <Spline
      className="relative md:absolute -left-20 md:-top-20 md:-left-20 lg:-top-16 lg:-left-10 xl:left-16 xl:-top-8 xl:scale-[1.15]"
      scene="https://prod.spline.design/fk8D6wdDoom1gGnr/scene.splinecode"
      onLoad={onLoad}
    />
  ) : (
    <span className="lg:hidden">
      <Image
        src="/static/images/pages/enterprise-ai/iceberg-mobile.png"
        alt=""
        width={320}
        height={327}
        quality={100}
        layout="responsive"
      />
    </span>
  );
};

export default Iceberg;
